import { render, staticRenderFns } from "./clientManage.vue?vue&type=template&id=a5b9b4ca"
import script from "./clientManage.vue?vue&type=script&lang=js"
export * from "./clientManage.vue?vue&type=script&lang=js"
import style0 from "./clientManage.vue?vue&type=style&index=0&id=a5b9b4ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports